<template>
    <div v-if="quick_audios.audios.length>=1" class="audio-preview-container">
        <div class="single-file">
            <div class="title" :style="{'color':quick_audios.title.color}">{{quick_audios.title.text}}</div>
            <div class="play-button" @click="playPause()">
                <span class="iconfont icon-bofang play-button-icon" v-if="status!=STATUS_PLAYING"></span>
                <span class="iconfont icon-zanting play-button-icon" v-if="status==STATUS_PLAYING"></span>
            </div>
            <div class="file-name" :style="{'color':quick_audios.title.color}">{{$common.removeExtension(quick_audios.audios[current_music_index])}}</div>
            <audio id="audioPlayer" style="display:none" preload="metadata"></audio>
            <div :style="{'color':quick_audios.title.color}">{{current_time}}</div>
            <div class="progress-bar">
                <ProgressBar :value="progress_perc" :showValue="false" style="height: 6px"></ProgressBar>
            </div>
            <div style="{'color':quick_audios.title.color}" class="time-meter" v-if="duration!=''">
                <div>00:00:00</div>
                <div>{{duration}}</div>
            </div>
        </div>
        <div v-if="quick_audios.audios.length>1" class="file-list" :style="{'color':quick_audios.title.color}">
            <div v-for="(audio, index) in quick_audios.audios" :key="audio.id" class="file-container" :class="current_music_index==index?'playing':''" :style="{'border-bottom-color':quick_audios.title.color}" @click="playSelectedAudio(index)">
                <div><span class="iconfont icon-tianchongxing-" style="margin-right:5px"></span>{{$common.removeExtension(audio)}}</div>
                <span class="iconfont icon-xiayiyedanjiantou"></span>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressBar from 'primevue/progressbar';

export default {
  name: 'QuickAudio',
  components: {
    ProgressBar
  },
  data(){
    return {
        status:0,
        STATUS_ENDED:0,
        STATUS_PLAYING:1,
        STATUS_PAUSED:-1,
        current_music_index:0,
        progress_perc:0,
        current_time:'00:00:00',
        duration:'',
        NO_AUTO:0,
        CYCLE_AUTO:1,
        RANDOM_AUTO:2
    }
  },
  props: {
    quick_audios: null
  },
  methods:{
    playPause(){

        const audioPlayer=document.getElementById("audioPlayer");

        if(this.status==this.STATUS_PLAYING)
        {

            audioPlayer.pause();

        }
        else if(this.status==this.STATUS_PAUSED)
        {

            audioPlayer.play();

        }
        else if(this.status==this.STATUS_ENDED)
        {

            const audio=this.quick_audios.audios[this.current_music_index];

            this.$common.playMedia(audioPlayer, audio.filename, '');

        }

    },
    playSelectedAudio(index){

        if(this.current_music_index!=index||this.status!=this.STATUS_PLAYING)
        {

            this.current_music_index=index;

            this.playNextAudio();

        }

    },
    toHHMMSS(seconds) {

        seconds=Math.floor(seconds);

        var hours = Math.floor(seconds / 3600);

        var minutes = Math.floor((seconds % 3600) / 60); 

        var remainingSeconds = Math.floor(seconds % 60);  

        hours = hours < 10 ? '0' + hours : hours;

        minutes = minutes < 10 ? '0' + minutes : minutes; 

        remainingSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;  

        return hours + ':' + minutes + ':' + remainingSeconds;  
    },
    audioDuration(audio){

        const jsonMisc=JSON.parse(audio.misc);

        if(jsonMisc.audioduration>0)
            return this.toHHMMSS(jsonMisc.audioduration);
        else
            return '';

    },
    playNextAudio(){

        let audioPlayer=document.getElementById("audioPlayer");

        const audio=this.quick_audios.audios[this.current_music_index];

        this.$common.playMedia(audioPlayer, audio.filename, '');

    }        
  },
  mounted(){
    

      let audioPlayer=document.getElementById("audioPlayer");

      const _this=this;

      audioPlayer.oncanplay=()=>{

        if(_this.quick_audios.play_mode!=_this.NO_AUTO)
            audioPlayer.play();

      };

      audioPlayer.onplay=()=>{

          _this.status=_this.STATUS_PLAYING;

          _this.$common.confirmPlay(audioPlayer.src);

      };

      audioPlayer.onpause=()=>{

          _this.status=_this.STATUS_PAUSED;

      };

      audioPlayer.onended=()=>{

          _this.status=_this.STATUS_ENDED;
 
          _this.progress_perc=0;

          _this.current_time='00:00:00';
          
          let n = _this.quick_audios.audios.length;  

          if(_this.quick_audios.play_mode==_this.RANDOM_AUTO&&n>1)
          {

            let random = Math.floor(Math.random() * n);

            while(random==this.current_music_index)
              random = Math.floor(Math.random() * n);

            _this.current_music_index=random;

          }

          if(_this.quick_audios.play_mode==_this.CYCLE_AUTO&&n>1)
          {

            let next = (_this.current_music_index+1)%n;

            _this.current_music_index=next;

          }

          _this.duration=_this.audioDuration(_this.quick_audios.audios[_this.current_music_index]);

          _this.playNextAudio();

      };

      audioPlayer.ontimeupdate=()=>{
        
        _this.current_time=_this.toHHMMSS(audioPlayer.currentTime);
        
        _this.progress_perc=audioPlayer.currentTime/audioPlayer.duration*100;

      };

      audioPlayer.onerror=()=>{

        if(audioPlayer.src.endsWith('status-1'))
        _this.$toast.add({severity:'error', summary: '88 二维码', detail:'无效的音视频文件', life: 6000});

        if(audioPlayer.src.endsWith('status-2'))
        _this.$toast.add({severity:'error', summary: '88 二维码', detail:'已经超过试用播放次数，请联系二维码所有人或 88 二维码客服', life: 6000});

        if(audioPlayer.src.endsWith('status-3'))
        _this.$toast.add({severity:'error', summary: '88 二维码', detail:'音视频播放流量余额不足，请联系二维码所有人或 88 二维码客服', life: 6000});


     };

     this.duration=this.audioDuration(this.quick_audios.audios[this.current_music_index]);

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audio-preview-container{
    display: flex;
    flex-direction: column;
    max-height: 100%;
}
.audio-preview-container .single-file{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.audio-preview-container .single-file .title{
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 30px;
    text-align: center;
}
.audio-preview-container .single-file .file-name{
    font-size: 1.2rem;
    line-height: 3rem;
}
.audio-preview-container .single-file .play-button{
    margin:15px auto;
    padding:15px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    background-color: white;
    border-radius: 50%;
}
.audio-preview-container .single-file .play-button .play-button-icon{
    font-size: 35px;
    color:#2196f3;
}
.audio-preview-container .single-file .progress-bar{
    width:100%;
    margin-top: 10px;
}
.audio-preview-container .single-file .time-meter{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 5px;
}
.audio-preview-container .file-list{
    padding:10px 0;
    flex-shrink: 1;
    flex-grow: 1;
    overflow-y: scroll;
}

.audio-preview-container .file-list .file-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:10px 0;
    border-bottom-width: 1px;
    border-bottom-style: solid;
}

.audio-preview-container .file-list .playing{
    font-weight: 800;
}

.audio-preview-container .file-list .file-container:last-child{
    border-bottom-width: 0px !important;
}
</style>